import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-paper pt-24 pb-10 px-6 md:px-10">
    <div className="max-w-[1400px] mx-auto grid md:grid-cols-3 gap-16">
      <div className="md:col-span-2">
        <h3 className="font-serif text-5xl md:text-6xl tracking-tight max-w-xl leading-[0.95]">
          Take a little piece of the prairie home.
        </h3>
        <Link to="/gallery/landscapes" data-testid="footer-shop-btn"
          className="inline-block mt-8 label border border-paper/40 px-8 py-4 hover:bg-brick hover:border-brick transition-colors duration-300">
          Browse the collection
        </Link>
      </div>
      <div className="flex flex-col gap-3 text-paper/70">
        <span className="label text-wheat mb-2">Prairie Prints MT</span>
        <span>Scobey, Montana</span>
        <a href="mailto:info@prairieprintsmt.com" className="hover:text-paper transition-colors">info@prairieprintsmt.com</a>
        <a href="https://www.instagram.com/prairieprintsmt/" target="_blank" rel="noreferrer" className="hover:text-paper transition-colors">Instagram</a>
        <a href="https://facebook.com/prairieprintsmt" target="_blank" rel="noreferrer" className="hover:text-paper transition-colors">Facebook</a>
      </div>
    </div>
    <div className="max-w-[1400px] mx-auto mt-20 pt-8 border-t border-line-dark flex flex-col md:flex-row justify-between gap-4 text-paper/50 label">
      <span>© {new Date().getFullYear()} Prairie Prints MT LLC</span>
      <span>Archival prints · Rated to last 100 years</span>
    </div>
  </footer>
);
